import { NgModule } from '@angular/core';
import { ChipComponent } from './chip.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [ChipComponent],
  exports: [ChipComponent],
})
export class ChipModule {}
